import { Link } from 'react-router-dom';
import { Category } from '@/mocks/categories';

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300"
    >
      <div className="aspect-[5/3] overflow-hidden bg-background-100">
        <img
          src={category.thumbnail}
          alt={category.name}
          title={`蘑菇视频${category.name}分类`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
            <i className={`${category.icon} text-sm`}></i>
          </div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
            {category.name}
          </h3>
        </div>
        <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
          {category.description}
        </p>
        <span className="text-xs text-foreground-400 font-label">
          {category.videoCount.toLocaleString()} 个视频
        </span>
      </div>
    </Link>
  );
}